import React from "react";
import { useTranslation } from "hooks";
import { OtherScoreCompletedReport } from "types";
import { generatePath } from "react-router-dom";
import { routes } from "configs";

interface NotificationProps {
  report: OtherScoreCompletedReport;
}

const Notification: React.FC<NotificationProps> = ({ report }) => {
  const { t } = useTranslation();

  return (
    <>
      <p>
        {t("teacherSection.otherScoreReportReady", {
          name: report.studentName,
        })}
      </p>
      <a href={generatePath(routes.otherScore, { id: report.studentId })}>
        {t("teacherSection.otherScoreClickReport")}
      </a>
      {/* TODO: change*/}
      {/* <Link*/}
      {/*  to={{*/}
      {/*    pathname: generatePath(routes.otherScore, {*/}
      {/*      id: report.studentId,*/}
      {/*    }),*/}
      {/*  }}*/}
      {/* >*/}
      {/*  {t("teacherSection.otherScoreClickReport")}*/}
      {/* </Link>*/}
    </>
  );
};

export default Notification;
